import { css, SerializedStyles, Theme } from "@emotion/react"

export const partDetailWrapper = (theme: Theme): SerializedStyles => css`
	font-size: 16px;
	font-style: normal;
	line-height: normal;
	color: ${theme.palette.colors.gray900};
`

export const styleGoToCart = css`
	cursor: pointer;
	a {
		color: #0b75e1;
	}
`

export const stylePartContainer = (theme: Theme): SerializedStyles => css`
	display: flex;
	grid-template-columns: 1fr 1fr;
	gap: 2.5rem;
	width: 100%;

	${theme.breakpoints.down("sm")} {
		grid-template-columns: 1fr;
		flex-direction: column;
		align-items: center;
	}
`

export const stylePartImage = (theme: Theme): SerializedStyles => css`
	border-radius: 8px;
	border: 1px solid #e5e6e6;
	background: ${theme.palette.colors.white};
	display: flex;
	height: 384px;
	width: 384px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	${theme.breakpoints.down("sm")} {
		width: 100%;
	}

	img {
		border-radius: 8px;
	}
`

export const styleAddToCardContainer = css`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	padding-top: 14px;
	padding-bottom: 18px;
	background: var(--Brand-Cobalt, #0b75e1);
	height: 3.5rem;
	span {
		color: #ffffff;
		text-align: right;
		text-transform: uppercase;
	}
`

export const styleAddToCardLabel = (theme: Theme): SerializedStyles => css`
	font-weight: 700;
	color: ${theme.palette.colors.white};
	text-align: right;
	text-transform: uppercase;
	vertical-align: -webkit-baseline-middle;
`

export const styleQuantityControl = css`
	margin-top: 24px;
`

export const styleInStock = css`
	font-weight: 700;
	font-size: 20px;
	color: #10a85f;
	margin-top: 0px;
`

export const styleMoreInfoBtn = (theme: Theme): SerializedStyles => css`
	font-weight: 700;
	color: ${theme.palette.colors.blue500};
	font-size: 1rem;
	cursor: pointer;
	line-height: 1.5rem;
	margin-left: 1rem;
`

export const styleLabelDescription = css`
	font-weight: 700;
`

export const styleAlternatePartNumber = (theme: Theme): SerializedStyles => css`
	color: ${theme.palette.colors.gray700};
	font-weight: 400;
	line-height: 1.5rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 250px;
`

export const styleAlternatePartNumbersContainer = css`
	display: flex;
	flex-direction: row;
	row-gap: 0.25rem;
	flex-wrap: wrap;
	flex-direction: column;
	flex-wrap: nowrap;
	max-width: 100%;
	overflow: hidden;
`

export const alternatePartNumbersWrapper = (theme: Theme): SerializedStyles => css`
	display: flex;
	flex-direction: row;
	column-gap: 3rem;
	row-gap: 0.25rem;

	${theme.breakpoints.down("xs")} {
		flex-direction: column;
		column-gap: 0.5rem;
		margin-top: 1.5rem;
	}
`

export const partNumberWrapper = (theme: Theme): SerializedStyles => css`
	display: flex;
	flex-direction: row;
	column-gap: 3rem;
	margin: 1.5rem 0 0.5rem;

	${theme.breakpoints.down("xs")} {
		flex-direction: column;
		row-gap: 0.5rem;
	}
`

export const styleDetailsContainer = css`
	width: 100%;
`

export const styleOnlinePartNumber = css`
	font-weight: 700;
`

export const styleContainerOnlinePartNumber = css`
	width: 192px;
	font-weight: 700;
`

export const styleBrandName = css`
	font-weight: 700;
	color: #003264;
	text-transform: uppercase;
`

export const stylePartTitle = css`
	h2 {
		color: #111827;
		font-size: 24px;
		font-weight: 700;
	}
`

export const clearanceTag = (theme: Theme): SerializedStyles => css`
	min-width: 152px;
	min-height: 50px;
	background-color: #dc2626;
	display: flex;
	align-items: center;
	padding: 0.3rem 20px;
	position: absolute;
	z-index: 1;
	border-radius: 8px 0px;

	svg {
		margin-top: 5px;
		margin-right: 12px;
	}

	> p,
	> span {
		font-weight: 700;
		color: ${theme.palette.colors.white};
		font-size: 20px;
	}
`
export const priceContainer = (theme: Theme): SerializedStyles => css`
	margin: 1.5rem 0;
	display: flex;
	align-items: baseline;
	flex-direction: row;

	${theme.breakpoints.down("xs")} {
		flex-direction: column-reverse;
	}

	> div {
		margin-right: 4rem;

		${theme.breakpoints.down("xs")} {
			margin-bottom: 1rem;
		}
	}

	p.priceTitle {
		font-size: 1.563rem;
	}
`
export const quantitySelectCss = css`
	select {
		height: 3.5rem;
		width: 7.5rem;
	}
`

export const frequentlyBoughtTogetherCSS = (theme: Theme) => css`
	border: 1px solid #d1d5db;
	padding: 1.5rem;
	border-radius: 1.25rem;
	overflow-x: scroll;

	h3 {
		display: block;
		font-weight: 700;
		margin-bottom: 1rem;
	}

	h4 {
		color: #111827;
		font-size: 1.125rem;
		font-weight: 500;
		margin-top: 1rem;
		max-width: 10.8rem;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	p.onlinePartNumber {
		color: #4b5563;
		margin: 0.5rem 0;
	}

	button {
		margin-left: 1.5rem;

		span {
			margin-right: 0 !important;
			position: relative !important;
			top: 0 !important;
			height: auto !important;
			line-height: auto !important;
		}
	}
`

export const partsGrid = css`
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: minmax(6, 1fr);
	gap: 3rem;
`

export const partCard = css`
	display: flex;
	flex-direction: column;
	max-width: 100%;
	width: 14rem;
`

export const cardFooter = css`
	display: flex;
	align-items: end;
`
